import { useCallback, useEffect, useState } from "react";
import { getNicheOverview } from "./nicheApi";
import { NicheOverview } from "./types";

export interface UseNicheReturn {
    overview: NicheOverview | null;
    loading: boolean;
    error: boolean;
    refresh: () => Promise<void>;
}

export const useNiche = (enabled = true): UseNicheReturn => {
    const [overview, setOverview] = useState<NicheOverview | null>(null);
    const [loading, setLoading] = useState(enabled);
    const [error, setError] = useState(false);

    const refresh = useCallback(async (): Promise<void> => {
        try {
            setOverview(await getNicheOverview());
            setError(false);
        } catch {
            setError(true);
        } finally {
            setLoading(false);
        }
    }, []);

    // Add Post mounts this for every flow; only ad-hoc posts need it.
    useEffect(() => {
        if (enabled) void refresh();
    }, [enabled, refresh]);

    return { overview, loading, error, refresh };
};
